import { createSlice } from "@reduxjs/toolkit";
import { ERROR_TYPE } from "./constants";
import getErrorType from "./getErrorType";

const errorSlice = createSlice({
  name: "error",
  initialState: null,
  reducers: {
    clearError: () => null,
    setError: (currentError, { payload }) => {
      const currentErrorIsServerError =
        currentError && currentError.type === ERROR_TYPE.server;
      const { message } = payload;
      const nextError = currentErrorIsServerError
        ? { ...currentError }
        : { message };

      return {
        type: getErrorType(nextError),
        ...payload,
      };
    },
  },
});

export const CLEAR_ERROR = errorSlice.actions.clearError.type;
export const SET_ERROR = errorSlice.actions.setError.type;

export const { clearError, setError } = errorSlice.actions;
export { getError, isErrorOfTypeServer } from "./selectors";
export { ERROR_TYPE } from "./constants";

export default errorSlice.reducer;
